module.exports = __webpack_public_path__ + "img/section-3-content_1_t_icon2_native.6575ec06.png";